import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {FeatureComponent} from "./feature.component";
import {ROUTES} from "@enums";
import {RequestSstComponent} from "./request/pages/request-sst/request-sst.component";
import {NaturalPersonProfileComponent} from "../core/components/natural-person-profile/natural-person-profile.component";
import {LegalPersonProfileComponent} from "../core/components/legal-person-profile/legal-person-profile.component";

import {CoordinatorGuard} from "../core/guards/coordinator.guard";
import {ValidatorGuard} from "../core/guards/validator.guard";
import {ReportsReturnedComponent} from "./reports/components/reports-returned/reports-returned.component";
import { ReportsCanceledComponent } from './reports/components/reports-canceled/reports-canceled.component';
import {ReportsConsultationCcComponent} from "./reports/components/reports-consultation-cc/reports-consultation-cc.component";
import {ReportsLicensesgeneratedComponent} from "./reports/components/reports-licensesgenerated/reports-licensesgenerated.component";
import {ReportsDashboardComponent} from "./reports/components/reports-dashboard/reports-dashboard.component";
import {ReportsRevokedComponent} from "./reports/components/reports-revoked/reports-revoked.component";
import {ReportsMinisterioComponent} from "./reports/components/reports-ministerio/reports-ministerio.component";
import {ReportsSolicitudesComponent} from "./reports/components/reports-solicitudes/reports-solicitudes.component";

import { ValidatorDashboardComponent } from './tracking/components/validator-dashboard/validator-dashboard.component';
import {UserDashboardComponent} from "./request/components/user-dashboard/user-dashboard.component";
import {
  PoliticaDatosPersonalesComponent
} from "../core/components/politica-datos-personales/politica-datos-personales.component";
import {DirectorGuard} from "../core/guards/director.guard";
import {CiudadanoGuard} from "../core/guards/ciudadano.guard";
import {FuncionarioGuard} from "../core/guards/funcionario.guard";

import {RegisterGuard} from "../core/guards/register.guard";

const routes: Routes = [
  {
    path: '',
    component: FeatureComponent,
    data: {
      breadcrumb: [
        {
          label: 'Bandeja de Entrada',
          url: ROUTES.Dashboard
        }
      ]
    },
    children: [
      {
        path: ROUTES.RegistrationNatural,
        component: NaturalPersonProfileComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.RegistrationNatural,
            }, {
              label: 'Licencia SST',
              url: ROUTES.RegistrationNatural
            }
          ]
        },
        canActivate: [RegisterGuard]//TramiteAuthGuard ],
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.RegistrationLegal,
        component: LegalPersonProfileComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.RegistrationLegal,
            }, {
              label: 'Licencia SST',
              url: ROUTES.RegistrationLegal
            }
          ]
        },
        canActivate: [ RegisterGuard]//TramiteAuthGuard ],
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.ACEPTAR_POLITICA_DATOS,
        component: PoliticaDatosPersonalesComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ACEPTAR_POLITICA_DATOS,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ACEPTAR_POLITICA_DATOS
            }
          ]
        },
        canActivate: [RegisterGuard]//TramiteAuthGuard ],
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.AddRequestProcedure15,
        data: {
          breadcrumb: [
            {
              label: 'Inicio',
              url: null,
            },
            {
              label: 'Licencia SST',
              url: null,
            },
            {
              label: 'Crear solicitud',
              activate: true,
              url: null,
            },
          ],
        },
        component: RequestSstComponent,
        canActivate: [ CiudadanoGuard],//TramiteAuthGuard ],
        //canDeactivate: [ PendingChangesGuard ] // MsalGuard
      }, {
        path: ROUTES.PERSON_DASHBOARD,
        data: {
          breadcrumb: [
            {
              label: 'Inicio',
              url: null,
            },
            {
              label: 'Licencia SST',
              url: null,
            },
            {
              label: 'Consultar solicitud',
              activate: true,
              url: null,
            },
          ],
        },
        component: UserDashboardComponent,
        canActivate: [ CiudadanoGuard]//TramiteAuthGuard ],
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      }, {
        path: ROUTES.ValidatorDashboard,
        component: ValidatorDashboardComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ValidatorDashboard,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ValidatorDashboard
            }, {
              label: 'Validacion solicitudes',
              activate: true,
              url: null,
            }
          ]
        },
        canActivate: [ ValidatorGuard]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      }/*,{
        path: ROUTES.RecoverPassword,
        component: RecoverPasswordComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.RecoverPassword,
            }, {
              label: 'Licencia SST',
              url: ROUTES.RecoverPassword
            }
          ]
        },
        canActivate: [AuthGuard,MsalGuard]//TramiteAuthGuard ],
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      }*/,{
        path: ROUTES.CoordinatorDashboard,
        component: ValidatorDashboardComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.CoordinatorDashboard,
            }, {
              label: 'Licencia SST',
              url: ROUTES.CoordinatorDashboard
            }, {
              label: 'Validacion solicitudes',
              activate: true,
              url: null,
            }
          ]
        },
        canActivate: [CoordinatorGuard]//TramiteAuthGuard ],
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.DirectorDashboard,
        component: ValidatorDashboardComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.DirectorDashboard,
            }, {
              label: 'Licencia SST',
              url: ROUTES.DirectorDashboard
            }, {
              label: 'Validacion solicitudes',
              activate: true,
              url: null,
            }
          ]
        },
        canActivate: [ DirectorGuard]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },{
        path: ROUTES.ReportsDashboard,
        component: ReportsDashboardComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ReportsDashboard,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ReportsDashboard
            }, {
              label: 'Dashboard',
              activate: true,
              url: null,
            }
          ]
        },
        canActivate: [ FuncionarioGuard ]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.ReportsCanceled,
        component: ReportsCanceledComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ReportsCanceled,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ReportsCanceled
            }, {
              label: 'Trámites anulados',
              activate: true,
              url: null,
            }
          ]
        },
        canActivate: [FuncionarioGuard]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.ReportsReturned,
        component: ReportsReturnedComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ReportsReturned,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ReportsReturned
            }, {
              label: 'Trámites Devueltos',
              activate: true,
              url: null,
            }
          ]
        },
        canActivate: [FuncionarioGuard]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.ReportsRevoked,
        component: ReportsRevokedComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ReportsRevoked,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ReportsRevoked
            }, {
              label: 'Trámites Revocados',
              activate: true,
              url: null,
            }
          ]
        },
        canActivate: [ FuncionarioGuard]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.ReportsLicensesGenerated,
        component: ReportsLicensesgeneratedComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ReportsLicensesGenerated,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ReportsLicensesGenerated
            }, {
              label: 'Licencias Generadas',
              activate: true,
              url: null,
            }
          ]
        },
        canActivate: [ FuncionarioGuard]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.ReportsMinistry,
        component: ReportsMinisterioComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ReportsMinistry,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ReportsMinistry
            }, {
              label: 'Reporte Ministerio de Salud',
              activate: true,
              url: null,
            }
          ]
        },
        canActivate: [ FuncionarioGuard]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.ReportsCCSST,
        component: ReportsConsultationCcComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ReportsCCSST,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ReportsCCSST
            }, {
              label: 'Consulta trámites LSST por No. de Identificación',
              activate: true,
              url: null,
            }
          ]
        },
        canActivate: [ FuncionarioGuard]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.ReportsSolicitudes,
        component: ReportsSolicitudesComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ReportsSolicitudes,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ReportsSolicitudes
            }, {
              label: 'Solicitudes Trámites SST',
              activate: true,
              url: null,
            }
          ]
        },
        canActivate: [ FuncionarioGuard]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      }/*,
      {
        path: ROUTES.Person,
        component: PersonDashboardComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ReportsSolicitudes,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ReportsSolicitudes
            }
          ]
        },
        canActivate: [MsalGuard, DirectorGuard]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      },
      {
        path: ROUTES.EditPerson,
        component: EditInfoComponent,
        data:{
          breadcrumb: [
            {
              label: 'Inicio',
              url: ROUTES.ReportsSolicitudes,
            }, {
              label: 'Licencia SST',
              url: ROUTES.ReportsSolicitudes
            }
          ]
        },
        canActivate: [MsalGuard, DirectorGuard]
        // canDeactivate: [ PendingChangesGuard ] // MsalGuard
      }*/
    ]
  },{
    path:':id',
    component: FeatureComponent
  }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class FeatureRoutingModule {
}
